let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("48ML3"), load("jle6Z"), load("ab8Aq")]).then(() => parcelRequire('4TDF1'));